import firebase from './firebaseConfig';

// See development/demodeck-backend/docs/ANALYTICS.md for the canonical event spec.

function safe(fn) {
  try { return fn(); }
  catch (e) { /* swallow analytics errors — never break UX */ }
}

export function track(event, params = {}) {
  safe(() => firebase.analytics().logEvent(event, { client: 'web', ...params }));
}

export function setUser(user) {
  if (!user) {
    safe(() => firebase.analytics().setUserId(null));
    return;
  }
  safe(() => firebase.analytics().setUserId(user.uid));
  safe(() => firebase.analytics().setUserProperties({
    signup_method: signupMethod(user),
    app_install_age_days: installAgeBucket(),
  }));
}

const SIGNUP_METHODS = {
  'apple.com': 'apple',
  'google.com': 'google',
  password: 'email_legacy',
};

// Maps a Firebase auth user's provider id to the canonical analytics
// `method` value (see ANALYTICS.md). Shared by setUser + the signup event.
export function signupMethod(user) {
  const provider = (user?.providerData || [])[0]?.providerId;
  return SIGNUP_METHODS[provider] || provider || 'unknown';
}

export function setUserPlanProperty(plan) {
  safe(() => firebase.analytics().setUserProperties({ plan }));
}

export function setArtistCountProperty(count) {
  safe(() => firebase.analytics().setUserProperties({
    artist_count: String(Math.min(count || 0, 999)),
  }));
}

const INSTALL_KEY = 'analytics_install_date';

function installAgeBucket() {
  const now = Date.now();
  let stamped = Number(localStorage.getItem(INSTALL_KEY));
  if (!stamped) {
    stamped = now;
    try { localStorage.setItem(INSTALL_KEY, String(stamped)); } catch (e) { /* private mode */ }
  }
  const days = Math.floor((now - stamped) / (1000 * 60 * 60 * 24));
  if (days <= 0) return '0';
  if (days <= 7) return '1-7';
  if (days <= 30) return '8-30';
  if (days <= 90) return '31-90';
  return '90+';
}
